import React from "react";
import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import {StyledP1} from "../ui-base/styles";
import {useTranslation} from "react-i18next";

export const CreatePublisherError: React.FC<{open: boolean, onClose: any, type: 1 | 2}> = ({open, onClose, type}) => {
    const { t } = useTranslation('publisher');

    return (
        <Dialog
            maxWidth="sm"
            aria-labelledby="confirmation-dialog-title"
            open={open}
            onClose={onClose}
        >
            <DialogTitle>
                {type === 1 ? t('editProfileFirstTime.createPublisherValidError1Title') : t('editProfileFirstTime.createPublisherValidError2Title')}
                </DialogTitle>
            <DialogContent dividers>
                {type === 1 &&
                    <>
                        <StyledP1>{t('editProfileFirstTime.createPublisherValidError1Content1')}</StyledP1>
                        <StyledP1>{t('editProfileFirstTime.createPublisherValidError1Content2')}</StyledP1>
                    </>
                }

                {type === 2 &&
                    <StyledP1>{t('editProfileFirstTime.createPublisherValidError2Content1')}</StyledP1>
                }
            </DialogContent>
        </Dialog>
    );
}